<template>
  <div class="rt-header-icon-wrapper">
    <rt-icon :name="icon" :img-src="iconSrc" :size="iconSize"></rt-icon>
  </div>
</template>

<script>
import RtIcon from '../../icon/rtIcon';
export default {
  name: 'RtHeaderIcon',
  components: {
    RtIcon
  },
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconSrc: {
      type: String,
      default: ''
    },
    iconSize: {
      type: [Number, String],
      default: 32
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtHeaderIcon.vue?f65b8e74